
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/android/local/dashboard",
      function () {
        return require("private-next-pages/android/local/dashboard.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/android/local/dashboard"])
      });
    }
  